import React from "react"
import { Link, graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { rhythm, scale } from "../utils/typography"

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.mdx
  const siteTitle = data.site.siteMetadata.title
  const { previous, next } = pageContext
  const image = post.frontmatter.image
    ? post.frontmatter.image.childImageSharp.resize
    : null

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        title={post.frontmatter.title}
        image={image}
        description={post.frontmatter.description || post.excerpt}
        pathname={location.pathname}
      />
      <article>
        <header>
          <h1
            style={{
              marginTop: rhythm(1),
              marginBottom: 0,
            }}
          >
            {post.frontmatter.title}
          </h1>
          <p
            style={{
              ...scale(-1 / 5),
              display: `block`,
              marginBottom: rhythm(1),
            }}
          >
            {post.frontmatter.date}
          </p>
        </header>
        <MDXRenderer>{post.body}</MDXRenderer>
        <br
          style={{
            marginBottom: rhythm(2),
          }}
        />
        <footer>
          <div
            style={{
              background: "#f2f2f2",
              color: "#2a2a2a",
              padding: "20px",
              display: "flex",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <i style={{ borderBottom: "0", margin: "0" }}>
              Thanks for reading! If you have comments or questions, please join our{" "}
              <a href="https://research.statechannels.org" target="_blank">
                discussion forum
              </a>
              . We're also on Twitter{" "}
              <a href="https://twitter.com/statechannels" target="_blank">
                @statechannels
              </a>
              ! All of our code is MIT licensed and available on{" "}
              <a href="https://github.com/statechannels" target="_blank">
                GitHub
              </a>
              .
            </i>
            <div style={{ flexGrow: 1 }}></div>
          </div>
        </footer>
      </article>

      <br
        style={{
          marginBottom: rhythm(2),
        }}
      />

      <nav>
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
      <br
        style={{
          marginBottom: rhythm(2),
        }}
      />
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      body
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        image: featured {
          childImageSharp {
            resize(width: 1200) {
              src
              height
              width
            }
          }
        }
      }
    }
  }
`
